const SAFE_ERROR_MESSAGE_KEYS = new Set(["detail", "message", "msg"]);

const collectErrorMessages = (value: unknown, visited = new WeakSet<object>()): string[] => {
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed ? [trimmed] : [];
  }

  if (!value || typeof value !== "object") {
    return [];
  }

  if (value instanceof Error) {
    return collectErrorMessages(value.message, visited);
  }

  if (visited.has(value)) {
    return [];
  }
  visited.add(value);

  if (Array.isArray(value)) {
    return value.flatMap((item) => collectErrorMessages(item, visited));
  }

  return Object.entries(value)
    .filter(([key]) => SAFE_ERROR_MESSAGE_KEYS.has(key))
    .flatMap(([, item]) => collectErrorMessages(item, visited));
};

export const getSignupErrorMessage = (error: unknown) => {
  const values = collectErrorMessages(error);
  return values.join(" ") || "Something went wrong. Please try again.";
};
